import {
    IStatusType,
} from '../types';

import failCircleIcon from '../media/fail-circle.svg';
import successCircleIcon from '../media/success-circle.svg';

export function formatCircle(type: IStatusType): string {
    switch (type) {
        case 'SUCCESS': {
            return successCircleIcon;
        }
        case 'FAILED':
        case 'NOT_FOUND': {
            return failCircleIcon;
        }
    }
}
